function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "#C5291C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.26609 12.96C6.60552 12.2996 7.10302 11.6996 7.7302 11.1942C8.35738 10.6887 9.10195 10.2878 9.9214 10.0143C10.7408 9.74075 11.6191 9.59996 12.5061 9.59996C13.3931 9.59996 14.2713 9.74075 15.0908 10.0143C15.9102 10.2878 16.6548 10.6887 17.282 11.1942C17.9092 11.6996 18.4067 12.2996 18.7461 12.96",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9306 4.09697L16.1214 4.66867",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.65603 4.68353L10.8392 4.08324",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.254 5.18184C18.254 5.18184 19.6013 5.79268 20.0122 6.81594C20.1909 7.26111 19.9111 7.79228 19.3867 8.00293C18.8617 8.21347 18.2922 8.0233 18.1134 7.57812C17.9145 7.08264 18.254 5.18184 18.254 5.18184Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1759 8.0627C20.1759 8.0627 21.5232 8.67354 21.934 9.6968C22.1128 10.142 21.833 10.6731 21.3086 10.8838C20.7836 11.0943 20.2141 10.9042 20.0353 10.459C19.8364 9.9635 20.1759 8.0627 20.1759 8.0627Z",
  fill: "black"
});

var Svg9NineSevere = function Svg9NineSevere(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg9NineSevere, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/9_nine_Severe.03ec31f7.svg";
export { ForwardRef as ReactComponent };